import styles from './entries-by-letter.module.scss';
import { artCollectorRoute } from 'lib/routes';
import LinkButton from 'components/controls/links/link-button'; // wtf is a LinkButton
import PropTypes from 'prop-types';

const EntriesByLetter = ({ letter, entries }) => {
	return (
		<div key={letter} className={styles.entriesByLetter}>
			<div className={styles.letter}>
				<h2>{letter}</h2>
			</div>
			<div>
				<ul>
					{entries.map((collector) => {
						return (
							<li className={styles.entry} key={collector._id}>
								<LinkButton
									text={collector.indexEntry}
									href={`/${artCollectorRoute}/${collector.slug?.current}`}
								/>
								<span className={styles.lifetime}>
									{collector.lifetimeDescriptor}
								</span>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

EntriesByLetter.propTypes = {
	entries: PropTypes.arrayOf(PropTypes.object).isRequired,
	letter: PropTypes.string.isRequired,
};

export default EntriesByLetter;
